module.exports = __webpack_public_path__ + "static/media/item__food-5.8637d2da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/dinerGame/item__food-5.png
// module id = 2330
// module chunks = 0